export const errors = {
  'Account is not active': 'account is no longer active',
  'Email is already in use': 'this email is already in use',
  'Email is not registered': 'account with this email is not registered',
  'Email not registered': 'account with this email is not registered',
  'Failed to fetch': 'the server is not responding',
  'Wrong password': 'password is incorrect',
}
